import gql from 'graphql-tag';
import { graphql } from '@apollo/client/react/hoc';

import { orderItemFragment } from '../../lib/order/fragments/orderItemsFragment';

export const query = gql`
  mutation AddPromoCodeToOrder($orderId: PositiveInt!, $code: String!) {
    addOrderItemV2(orderId: $orderId, item: { Promo: { code: $code } }) {
      id
      userId
      status
      amountDue
      type
      orderItems {
        ...OrderItemFragment
      }
    }
  }

  ${orderItemFragment}
`;

const config = {
  props: ({ mutate }) => ({
    applyPromo: async ({ code, orderId }) => {
      await mutate({
        variables: {
          orderId,
          code,
        },
      });
    },
  }),
};

const withApplyPromoMutation = () => graphql(query, config);

export default withApplyPromoMutation;
